import { StylishNewButton } from '../../DesignSystems/New/StylishNewButton';
import React from 'react';
import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import { SITREP_SECTION_STEPS } from './types';

/**
 * This component renders three possible buttons:
 *
 * - Back: Goes to the previous step (if not on the first step)
 * - Next: Goes to the next step (if not on the last step)
 * - Create: Finalizes the section (if on the last step)
 */
const SitrepSectionWizardFooter = () => {
  const {
    activeStep,
    sectionName,
    handleNext,
    handleBack,
    handleCreateSectionTemplate,
  } = useSitrepSectionWizardContext();

  return (
    <div className="sidebar-footer d-flex justify-content-end gap-3 px-3 align-self-end position-fixed">
      {activeStep.id > 1 && (
        <StylishNewButton
          className="button--secondary color-white"
          onClick={handleBack}
        >
          Back
        </StylishNewButton>
      )}
      {activeStep.id < SITREP_SECTION_STEPS.length && (
        <StylishNewButton
          className="button--primary color-black"
          onClick={handleNext}
          disabled={!sectionName}
        >
          Next
        </StylishNewButton>
      )}
      {activeStep.id === SITREP_SECTION_STEPS.length && (
        <StylishNewButton
          className="button--primary color-black"
          onClick={handleCreateSectionTemplate}
        >
          Create
        </StylishNewButton>
      )}
    </div>
  );
};

export default SitrepSectionWizardFooter;
